exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".blockRow{padding:.75rem}.blockRow.red>.block{background-color:#ff3a24}.blockRow.orange>.block{background-color:#e67e22}.blockRow.yellow>.block{background-color:#f1c40f}.blockRow.green>.block{background-color:#2ecc71}.blockRow.turquoise>.block{background-color:#1abc9c}.blockRow.blue>.block{background-color:#3498db}.blockRow.purple>.block{background-color:#9b59b6}.blockRow.pink>.block{background-color:#ff2470}.blockRow.lightGray>.block{background-color:#ecf0f1}.blockRow.darkGray>.block{background-color:#95a5a6}.blockRow.black>.block{background-color:#34495e}.blockRow.white>.block{background-color:#fff}.blockRow>.block.new{background-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-9e427ee6!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/BlockRow.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-9e427ee6!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/BlockRow.vue
// module chunks = 0